import React from 'react';

export default function Section(props) {
    return <div className="w-section">{props.children}</div>;
}
